import { CountryService } from './countryservice';
import { CustomerService } from './customerservice';
import { EventService } from './eventservice';
import { IconService } from './iconservice';
import { NodeService } from './nodeservice';
import { PhotoService } from './photoservice';
import { ProductService } from './productservice';

export const PrimeNgServices = [
  CountryService,
  CustomerService,
  EventService,
  IconService,
  NodeService,
  PhotoService,
  ProductService
];
